class AxArticleShare extends HTMLElement {
  #timeout = 0;

  connectedCallback() {
    this.querySelector('button')?.addEventListener('click', () => this.#share());
  }

  async #share() {
    const { title, url, copied } = this.dataset;

    if (navigator.share) {
      // AbortError = partage annulé par l'utilisateur, rien à signaler.
      await navigator.share({ title, url }).catch(() => {});
      return;
    }

    try {
      await navigator.clipboard.writeText(url);
    } catch {
      window.prompt('', url);
      return;
    }

    const status = this.querySelector('[role="status"]');
    if (!status) return;
    status.textContent = copied;
    clearTimeout(this.#timeout);
    this.#timeout = setTimeout(() => (status.textContent = ''), 2500);
  }
}

if (!customElements.get('ax-article-share')) {
  customElements.define('ax-article-share', AxArticleShare);
}
